import {createApp} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import Gallery from '../components/global/gallery.vue';
import EnquireForm from '../components/global/enquire-form.vue';
import trackSocialClicks from '../helpers/trackSocialClicks';

const app = createApp({
    props: ['id', 'title', 'category'],
    components: {
        'gallery': Gallery,
        'brochure-button': EnquireForm,
        'testdrive-button': EnquireForm,
        'question-button': EnquireForm,
        'enquire-form': EnquireForm,
    },

    data() {
        return {
            email: '',
        };
    },
    methods: {
    // reviews
        socialClick(type: string, url: string) {
            trackSocialClicks(type);
            if (type !== 'whatsapp') {
                window.open(url, 'enquire form', 'width=600, height=400');
            }
        },
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);

app.mount('#app');
